var render = function render(){var _vm=this,_c=_vm._self._c;return _c('standardTable',{attrs:{"standard":_vm.$store.getters.standard,"standardTitle":_vm.$store.getters.standardTitle}})
}
var staticRenderFns = []

export { render, staticRenderFns }